/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

type Props = {
  error: string;
};

function ShortCodeError({ error }: Props) {
  return (
    <div css={{ backgroundColor: '#f00', color: '#fff', padding: '8px 16px' }}>
      <h4>Short Code Error</h4>
      <p>{error}</p>
    </div>
  );
}

export default ShortCodeError;
